import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'

import { Loading } from 'element-ui'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL, commented out because of this # https://github.com/vuejs/vue-cli/issues/2380
  base: '/', // we live at: https://appraisal.owiwi.co.uk,
  routes: [
    { path: '*', redirect: '/login' }, // could be 404 error page

    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      meta: { guest: true },
      // route level code-splitting
      // this generates a separate chunk (login.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login')
    },
    {
      path: '/appraisal/start',
      name: 'start',
      meta: { authenticated: true },
      component: () => import(/* webpackChunkName: "appraisal" */ '@/views/Start'),
      beforeEnter: async(to, from, next) => {
        if (store.getters.hasStarted) {
          next({ path: '/appraisal' })
        }
        else {
          next()
        }
      }
    },
    {
      path: '/appraisal',
      name: 'appraisal',
      meta: { authenticated: true },
      component: () => import(/* webpackChunkName: "appraisal" */ '@/views/Appraisal'),
      beforeEnter: async(to, from, next) => {
        if (store.getters.isEvaluator) {
          if (store.getters.isEvaluatorButCandidate) {
            if (store.getters.isCompletedByCandidate) {
              next({ path: '/appraisal/completed' })
            }
            else {
              next()
            }
          }
          else {
            if (store.getters.isFirstEvaluator) {
              if (store.getters.isCompletedByFirstEvaluator) {
                next({ path: '/appraisal/completed' })
              }
              else {
                next()
              }
            }
            else {
              if (store.getters.isCompletedBySecondEvaluator) {
                next({ path: '/appraisal/completed' })
              }
              else {
                next()
              }
            }
          }
        }
        else {
          if (store.getters.isCompletedByCandidate) {
            next({ path: '/appraisal/completed' })
          }
          else {
            next()
          }
        }
      }
    },
    {
      path: '/evaluator/:id',
      name: 'evaluator',
      meta: { authenticated: true },
      component: () => import(/* webpackChunkName: "appraisal" */ '@/views/Appraisal'),
      beforeEnter: async(to, from, next) => {
        const id = to.params.id
        store.commit('setAssessmentId', id)
        console.log((store.getters.isSecondEvaluator && store.getters.isCompletedBySecondEvaluator))
        if (store.getters.isCompleted && !store.getters.isEvaluator) {
          next({ path: '/appraisal/completed' })
        }
        else if (store.getters.isEvaluator && (store.getters.isFirstEvaluator && store.getters.isCompletedByFirstEvaluator) || (store.getters.isSecondEvaluator && store.getters.isCompletedBySecondEvaluator)) {
          next({ path: '/appraisal/completed' })
        }
        else {
          next()
        }
      }
    },
    {
      path: '/appraisal/completed',
      name: 'completed',
      meta: { authenticated: true },
      component: () => import(/* webpackChunkName: "appraisal" */ '@/views/Completed'),
      beforeEnter: async(to, from, next) => {
        if (store.getters.isEvaluator) {
          if (store.getters.isEvaluatorButCandidate) {
            if (store.getters.isCompletedByCandidate) {
              next()
            }
            else {
              next({ path: '/appraisal' })
            }
          }
          else {
            if (store.getters.isFirstEvaluator) {
              if (store.getters.isCompletedByFirstEvaluator) {
                next()
              }
              else {
                next({ path: '/appraisal' })
              }
            }
            else {
              if (store.getters.isCompletedBySecondEvaluator) {
                next()
              }
              else {
                next({ path: '/appraisal' })
              }
            }
          }
        }
        else {
          if (store.getters.isCompletedByCandidate) {
            next()
          }
          else {
            next({ path: '/appraisal' })
          }
        }
      }
    }
  ]
})

router.beforeEach(async(to, from, next) => {
  const loader = Loading.service({ fullscreen: true, text: 'Loading your assessment...' })

  // Try auto-login
  if (!store.getters.isAuthenticated) await store.dispatch('tryAutoLogin', { route: to })

  // Init Game
  if (!store.getters.gameplay) await store.dispatch('getGameplay')

  loader.close()

  // Authentication guards
  if (store.getters.isAuthenticated && to.matched.some(record => record.meta.guest)) {
    next({ path: '/appraisal' })
    return
  }
  else if (!store.getters.isAuthenticated && to.matched.some(record => record.meta.authenticated)) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  next()
})

export default router
